var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBandList)?_c('div',[_vm._l((_vm.multiSectionList),function(sectionInfo,index){return [_c('DynamicSectionLoader',{key:sectionInfo.title + _vm.$route.name + index,attrs:{"section-info":sectionInfo}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }